// ==== Newlook js code ==============//
$(document).ready(function(){
  var $mushroom = $(".mushroom_inside_container .mushroom-wrapper");
  if($mushroom){
   var itemCount = $mushroom.find("li").length;
    if(itemCount > 1){
    $mushroom.owlCarousel({
        margin: 20,
        nav: true,
        navText: [
        '<span class="owl-prev-icon">&#10094;</span>', 
        '<span class="owl-next-icon">&#10095;</span>'
        ],
        autoplay: false,
        loop: (itemCount > 1),
        responsive:{
        0:{ items:1, nav:false },
        768:{ items: (itemCount > 1 ? 2 : 1) }, 
        1200:{ items: (itemCount > 1 ? 2 : 1) }
        }
    });
    }
  }

if($(".certification-wrap .certification-list")){
  var $certification = $(".certification-wrap .certification-list");
  function initCertSlider() {
       if ($(window).width() < 768) {
        $certification.owlCarousel({
                margin: 20,
                nav: true,
                 navText: [
                '<span class="owl-prev-icon">&#10094;</span>', 
                '<span class="owl-next-icon">&#10095;</span>'
                ],
                autoplay: false,
                loop: 1,
                responsive:{
                0:{ items:1, nav:false },
                768:{ items:5, nav:false }, 
                1200:{ items:5, nav:false }
                }
            });
        }else {
            if ($certification.hasClass("owl-loaded")) {
                $certification.trigger("destroy.owl.carousel").removeClass("owl-carousel owl-loaded");
                $certification.find(".owl-stage-outer").children().unwrap();
            }
        }
  }
 initCertSlider();
  $(window).resize(function () {
    initCertSlider();
  });
}

if($(".mushroom_inside_container .toggle-details")){
  $(".mushroom_inside_container .toggle-details").on("click", function(){
    var $details = $(this).siblings(".details_field");
    $details.toggleClass("active");

    // Toggle + to ×
    if($details.hasClass("active")){
      $(this).text("×");
    } else {
      $(this).text("+");
    }
  });
}
});
  // ======= End NewLook JS CODE===========//